export default "__VITE_ASSET__dcbc2296__"